<template>
    <div>
        <!--导航栏 start-->
        <div class="main">
            <div class="main-div">
                <van-nav-bar title="我的账户" left-text="返回" @click-left="onClickLeft" left-arrow fixed />
                <!--导航栏 end-->
                <!--内容 start-->
                <div style=" margin-top: 1.2rem;height: 4rem;background-color: rgb(6,180,253);">
                    <van-grid id="van_grid" style="height: 2.4rem;" :border="false" :column-num="1">
                        <van-grid-item style="font-weight: bold;color: white; ">
                            <div style="font-size: 15px;margin-bottom: 0.15rem">{{ form.name }}</div>
                            <div style="font-size: 1rem;font-weight: bold;color: white;">￥{{ form.money }}</div>
                        </van-grid-item>
                    </van-grid>
                    <div style="text-align: center;">
                        <van-button @click="appley"
                            style="margin: 0.4rem 0;height: 35px;color: white;border: solid 1px white;background-color:rgb(6,180,253); "
                            round plain hairline type="info">申请提现</van-button>
                    </div>
                    <!--                    <van-dropdown-menu>-->
                    <!--                        <van-dropdown-item  ref="items" :title="merchant_id==''?'全部商户':merchant_name">-->
                    <!--                            <div style="height: 13rem;overflow-y: scroll">-->
                    <!--                                <van-cell @click="pagexmer()"  title="全部商户" is-link/>-->
                    <!--                                <div v-for="(bububu,index) in option2" :key="index">-->
                    <!--                                    <van-cell @click="outlets(bububu.value,bububu.label)" :title="bububu.label" is-link/>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </van-dropdown-item>-->

                    <!--                        <van-dropdown-item  ref="item" :title="store_id==''?'全部门店':store_name" >-->
                    <!--                            <van-cell @click="pagex()"  title="全部门店" is-link/>-->
                    <!--                            <div v-for="(bububu,index) in option1" :key="index">-->
                    <!--                                <van-cell @click="outlet(bububu.value,bububu.label)" :title="bububu.label" is-link/>-->
                    <!--                            </div>-->
                    <!--                        </van-dropdown-item>-->
                    <!--                    </van-dropdown-menu>-->

                    <!--                            <van-dropdown-menu >-->
                    <!--                               -->
                    <!--                            </van-dropdown-menu>-->

                    <!--                    <van-tabs class="van_tabs" color="rgb(0,170,238)" title-active-color="black" @click="onClick(active)"  id="vat_tabs" v-model="active">-->
                    <!--                        <van-tab  title="日报表">-->
                    <!--                            <van-grid :column-num="3" :border="false" id="vat_grid" >-->
                    <!--                                <van-grid-item  text="交易时间" />-->
                    <!--                                &lt;!&ndash; <van-grid-item  text="门店" /> &ndash;&gt;-->
                    <!--                                <van-grid-item  text="交易笔数" />-->
                    <!--                                <van-grid-item  text="交易金额" />-->
                    <!--                            </van-grid>-->
                    <!--                        </van-tab>-->
                    <!--                        <van-tab title="周报表">-->
                    <!--                            <van-grid :column-num="3" :border="false" id="vat_grid">-->
                    <!--                                <van-grid-item  text="交易时间" />-->
                    <!--                                &lt;!&ndash; <van-grid-item  text="门店" /> &ndash;&gt;-->
                    <!--                                <van-grid-item  text="交易笔数" />-->
                    <!--                                <van-grid-item  text="交易金额" />-->
                    <!--                            </van-grid>-->
                    <!--                        </van-tab>-->
                    <!--                        <van-tab title="月报表">-->
                    <!--                            <van-grid :column-num="3" :border="false" id="vat_grid">-->
                    <!--                                <van-grid-item  text="交易时间" />-->
                    <!--                                &lt;!&ndash; <van-grid-item  text="门店" /> &ndash;&gt;-->
                    <!--                                <van-grid-item  text="交易笔数" />-->
                    <!--                                <van-grid-item  text="交易金额" />-->
                    <!--                            </van-grid>-->
                    <!--                        </van-tab>-->
                    <!--                    </van-tabs>-->
                </div>
            </div>
        </div>
        <!--内容 end-->
        <div class="content">
            <div style="background-color: white;">
                <span
                    style=" font-size: 13px ;color: rgb(6,180,253);background-color: rgb(6,180,253);padding: 0;margin: 0 0.1rem;border: solid 1px rgb(6,180,253);"></span>
                <span style="color: gray;font-size: 14px ;font-weight: bold;margin-left: 1px">提现记录</span>
                <van-grid :column-num="3" :border="false">
                    <van-grid-item text="提现金额" />
                    <!--                    <van-grid-item  text="留言信息" />-->
                    <van-grid-item text="状态" />
                    <van-grid-item text="创建申请时间" />
                </van-grid>
            </div>
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
                <div v-for="(admin, index) in list" :key="index">
                    <van-grid :column-num="3" :border="false" @click.native="details(admin.id)">
                        <van-grid-item :text="admin.money + '元'" />
                        <!--                        <van-grid-item  :text="admin.remark?admin.remark:'&#45;&#45;'" />-->
                        <van-grid-item>
                            <van-tag
                                :type="admin.status == 0 ? 'warning' : (admin.status == 1 ? 'primary' : (admin.status == -1 ? 'danger' : 'success'))">{{ admin.status == 0 ? '申请中' : (admin.status == 1 ? '打款中' : (admin.status == -1 ? '驳回' : '打款成功')) }}</van-tag>
                        </van-grid-item>
                        <van-grid-item style="text-align: center" :text="admin.apply_time" />
                    </van-grid>
                </div>
            </van-list>
        </div>
    </div>
</template>

<script>
// import {Toast} from 'vant';

// import VueCookie from "vue-cookies";

export default {
    name: "AgentSummary", //我的账户
    data() {
        return {
            list: [],
            loading: false,
            finished: false,
            page: 0,
            num: 10,
            form: {},
            min_money: '',
            query: {},

        }
    },
    methods: {
        // 左侧返回
        onClickLeft() {
            this.$router.push('/MyAgent')
        },
        appley() {
            this.$router.push({ path: "/ApplyWithdrawal", query: { list: this.query } })
        },

        details(id) {
            console.log('q11')
            this.$router.push({ path: "/ApplyWithDetails", query: { id: id } })
        },
        //查询提现信息
        theMerchants() {
            this.$http.get('/wechat/api.agent.money/withdrawInfo').then(response => {
                console.log(response.data.data);
                this.query = response.data.data
                this.form = response.data.data.agent
            })
        },

        // 触发下拉刷新更多
        onLoad() {
            this.page += 1;
            this.report()
        },
        //报表
        report() {
            var that = this
            this.$http.get('/wechat/api.agent.money/index', {
                params: {
                    // id: salesmanInfo.id,
                    pageNum: that.page,
                    pageSize: that.num
                }
            }
            ).then(response => {
                // console.log(response.data.data);
                // this.list=response.data.data
                that.loading = false;
                if (response.data.rows.length) {
                    that.list.push(...response.data.rows);
                    that.finished = false;
                }
                if (response.data.rows.length < that.num) {
                    that.finished = true;
                }
            })
        }


    },
    mounted() {
        this.theMerchants()

    }
}
</script>

<style scoped>
#vat_tabs {
    font-size: 0.6rem;
    /* border: solid 2px red; */

}

#vat_grid {
    position: relative;
    bottom: 0.1rem;
}

.main {
    /* position: sticky;
        top: 1.22rem; */
    z-index: 1000;
    position: relative;
}

.main-div {
    position: fixed;
    top: 0;
    width: 100%;
}

.content {
    margin-top: 5.1rem;
    /* border: solid 1px red; */
}

.van_tabs {
    /* border: solid 1px red; */
    position: relative;
    bottom: 0.1rem;
}

#van_menu {
    width: 46%;
}

#van_grid>>>.van-grid-item__content {
    background-color: rgb(6, 180, 253);
}
</style>
